export default {
  props: ['coursework'],
  template: '#gallery_participation_step_template',
  data() {
    return {
      number: 0,
      name: 'Gallery Participation',
      task: 'Leave comments in coursework gallery',
      isInView: false
    };
  },
  computed: {
    isVisible() {
      return this.coursework.has_gallery_participation_grading;
    },
    isActive() {
      return this.isVisible;
    },
    isComplete() {
      return !this.coursework.is_gallery_participation_pending;
    }
  },
  created() {
    this.$parent.steps.push(this);
  }
};
